import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as Common from '_common';
import * as Components from '_components';
import * as Utils from '_utils';
import * as Styles from './Process.module.scss';
export function RenderProcess(component, index) {
    return _jsx(ProcessComponent, { id: component.properties.id }, index);
}
export function ProcessComponent(props) {
    const context = Common.useSpaContext();
    const processes = context?.processes;
    if (props.id == 'debug1') {
        return _jsx(ProcessDisplay, { process: debugProcess1 });
    }
    if (props.id == null || !processes || !processes[props.id]) {
        return _jsx("div", { children: "Process not found" });
    }
    const processInfo = processes[props.id];
    if (!processInfo) {
        return _jsx("div", { children: "Process not found" });
    }
    return _jsx(ProcessDisplay, { process: processInfo });
}
export function ProcessDisplay(props) {
    return (_jsx("ul", { className: Styles.process, children: props.process.tasks.map((activity, index) => (_jsx(Activity, { activity: activity }, index))) }));
}
export function Activity(props) {
    const classes = Utils.classNames({
        [Styles.activity]: true,
        [Styles.pending]: props.activity.state === Common.ActivityState.Pending,
        [Styles.running]: props.activity.state === Common.ActivityState.InProgress,
        [Styles.completed]: props.activity.state === Common.ActivityState.Completed,
        [Styles.cancelled]: props.activity.state === Common.ActivityState.Cancelled,
        [Styles.failed]: props.activity.state === Common.ActivityState.Failed,
    });
    if (!props.activity.name || props.activity.name === 'hidden') {
        return null;
    }
    let progress = _jsx(_Fragment, {});
    if (props.activity.state === Common.ActivityState.InProgress) {
        if (props.activity.progress != null) {
            progress = (_jsxs(_Fragment, { children: [_jsx(Components.Progress, { value: props.activity.progress, max: 100, size: Components.ProgressSize.Small }), _jsx("small", { children: props.activity.progressString })] }));
        }
        else if (props.activity.progressString) {
            progress = _jsx("small", { children: props.activity.progressString });
        }
    }
    return (_jsxs("li", { className: classes, children: [_jsx("span", { className: Styles.activityState, children: props.activity.state }), _jsx("span", { className: Styles.activityName, children: props.activity.name }), _jsx("span", { className: Styles.activityProgress, children: progress })] }));
}
const debugProcess1 = {
    id: 'debug1',
    name: 'Debug Process',
    isRunning: true,
    started: new Date(),
    finished: new Date(),
    tasks: [
        {
            id: 'activity1',
            name: 'Activity 1',
            state: Common.ActivityState.Completed,
            started: new Date(),
            finished: new Date(),
            progress: 100,
            progressString: null,
        },
        {
            id: 'activity2',
            name: 'Activity 2',
            state: Common.ActivityState.InProgress,
            started: new Date(),
            finished: null,
            progress: 50,
            progressString: '0:35',
        },
        {
            id: 'activity21',
            name: 'Activity 21',
            state: Common.ActivityState.InProgress,
            started: new Date(),
            finished: null,
            progress: null,
            progressString: 'doing something...',
        },
        {
            id: 'activity3',
            name: 'Activity 3',
            state: Common.ActivityState.Pending,
            started: null,
            finished: null,
            progress: 0,
            progressString: null,
        },
        {
            id: 'activity4',
            name: 'Activity 4',
            state: Common.ActivityState.Cancelled,
            started: null,
            finished: null,
            progress: 0,
            progressString: null,
        },
        {
            id: 'activity5',
            name: 'Activity 5',
            state: Common.ActivityState.Failed,
            started: null,
            finished: null,
            progress: 0,
            progressString: null,
        },
    ],
};
